<template>
    <div
        class="absolute top-12 bg-white p-5 border w-[520px] right-[100px] z-[100] max-h-[370px] overflow-y-scroll rounded-lg">
        <div v-for="(notification, index) in visibleNotifications" :key="index">
            <div class="flex items-center gap-3 w-full justify-between">
            <div class="flex items-center gap-5">
                <i class="fas fa-file-alt rounded-[500px] bg-slate-300 p-3"></i>
                <div>
                    <p class="text-sm">{{ notification.msg }}</p>
                    <p class="text-sm text-slate-400 mt-6">{{ formatDate(notification.createdAt) }}</p>
                </div>
            </div>
            <i class="fas fa-times cursor-pointer" @click="emit('readNotification', notification)"></i>
            </div>
            <hr v-if="index < visibleNotifications.length - 1" class="w-full my-5" />
        </div>

        <div class="text-center text-sm" v-if="notifications.length === 0">Nenhuma notificação</div>

        <div v-if="visibleCount < notifications.length" class="text-center mt-4">
            <button @click="showMore" class="text-blue-500 underline text-sm">
                Mostrar mais
            </button>
            </div>
        </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useFormat } from '@/composables/useFormat'

const { formatDate } = useFormat()

const visibleCount = ref(3)

const props = defineProps({
    notifications: {
        type: Array,
        default: []
    }
})
const emit = defineEmits(['readNotification'])

const visibleNotifications = computed(() => {
  return props.notifications.slice(0, visibleCount.value)
})

const showMore = () => {
   visibleCount.value += 3
}

</script>
